class BulkAdd extends HTMLElement {
  static ASYNC_REQUEST_DELAY = 500;

  constructor() {
    super();
    this.queue = [];
    this.requestStarted = false;
    this.cartData = {};
  }

  startQueue(id, quantity) {
    if (this.queue.length > 0) {
      const queueIndex = this.queue.findIndex((item) => item.id === id);
      if (queueIndex !== -1) {
        this.queue[queueIndex] = { id, quantity };
      } else {
        this.queue.push({ id, quantity });
      }
    } else {
      this.queue.push({ id, quantity });
    }

    if (!this.requestStarted) {
      this.sendRequest();
    }
  }

  sendRequest() {
    this.setRequestStarted(true);
    const items = this.queue.reduce((acc, { id, quantity }) => {
      return { ...acc, [id]: quantity };
    }, {});
    this.queue = [];
    this.updateMultipleQty(items);
  }

  setRequestStarted(value) {
    this.requestStarted = value;
    if (!value && this.queue.length > 0) {
      this.sendRequest();
    }
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < parseInt(event.target.dataset.min)) {
      message = window.quickOrderListStrings?.min_error?.replace('[min]', event.target.dataset.min) || '';
    } else if (event.target.max && inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings?.max_error?.replace('[max]', event.target.max) || '';
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings?.step_error?.replace('[step]', event.target.step) || '';
    }

    if (message) {
      event.target.setCustomValidity(message);
      event.target.reportValidity();
    } else {
      event.target.setCustomValidity('');
      this.startQueue(index, inputValue);
    }
  }

  getCartQuantityForLine(id) {
    return this.cartData[id] || 0;
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  startCartLinesUpdate(items) {
    const { CartLinesUpdateEvent } = window.StandardEvents || {};
    if (!CartLinesUpdateEvent) return null;

    const lines = Object.entries(items).map(([id, quantity]) => ({ id, quantity }));
    const deferred = CartLinesUpdateEvent.createPromise();

    this.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'update',
        context: 'cart',
        lines,
        promise: deferred.promise,
      })
    );
    return deferred;
  }

  dispatchCartErrorEvent(message, code) {
    const { CartErrorEvent } = window.StandardEvents || {};
    if (!CartErrorEvent) return;
    this.dispatchEvent(new CartErrorEvent({ error: message, code }));
  }
}

